document.addEventListener('DOMContentLoaded', () => {
  // Look for our bundle scent dropdowns (line item properties)
  const scentSelects = document.querySelectorAll('select.bundle-scent');

  // Craft typically uses button[name="add"] inside product form
  const addToCartBtn =
    document.querySelector('product-form button[name="add"]') ||
    document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
    document.querySelector('button[name="add"]');

  // If we’re not on the bundle product page, do nothing
  if (!scentSelects.length || !addToCartBtn) return;

  const setButtonState = () => {
    const allSelected = Array.from(scentSelects).every((s) => (s.value || '').trim() !== '');
    addToCartBtn.disabled = !allSelected;
    addToCartBtn.classList.toggle('is-disabled-by-bundle', !allSelected);
    addToCartBtn.setAttribute('aria-disabled', String(!allSelected));
  };

  // Disable on load, then re-check on change
  setButtonState();
  scentSelects.forEach((s) => s.addEventListener('change', setButtonState));
});
